import { Form, Modal ,Input, Radio, DatePicker, Button} from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { AddNewVersion, axiosErrorMessages } from "../../../API/api";
import locale from 'antd/es/date-picker/locale/en_US'; // Import the locale file
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import axios, { AxiosError } from "axios";
const defaultDate = new Date('2024-01-30T04:16:14.2');
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;
interface AddEditVersion {
    editData:any;
    isEdit:boolean;
    handleClosePopup: (data: boolean) => void;softwareId:number;

  }
    const AddEditVersion: React.FC<AddEditVersion> = ({ editData,isEdit,handleClosePopup,softwareId }) => {
    const [isOpen,setIsOpen] = useState<boolean>(true)
    const [addEditVersionForm] = Form.useForm();
    const [isPaid,setIsPaid] = useState<string>('Paid')
    const [radioValue,setRadioValue] = useState("Paid")
    const rangeConfig = {
      rules: [{ type: 'array' as const, required: true, message: 'Please select Date' }],
    };
    const dateFormat = 'DD/MM/YYYY';

    type FieldType = {
      version?:string;
        paidFree?:string;
        startDate?:any;
        endDate?:string
      };
    const onClosePopup =()=>{setIsOpen(false); handleClosePopup(false)}
    const onSaveStatusHandler = (formData:any) => {
 
      const saveData = {
        softwareId:softwareId,
        versionId:isEdit ? editData.versionId:0,
        version:formData.version.trim(),
        isPaid:formData.paidFree === 'Paid' ? true:false,
        startDate:formData['startDate']?formData['startDate'].toISOString():new Date(),
        expiryDate:formData['endDate']?formData['endDate'].toISOString():new Date() 
    }
    AddNewVersion(saveData)
    .then((response:any)  =>{
      enqueueSnackbar("Added Successfully",{ variant: 'success', anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },})
      handleClosePopup(true)
    }).catch((error:any)  =>  {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    // }
    //   enqueueSnackbar("Error in fetching data",{ variant: 'error', anchorOrigin: {
    //     vertical: 'top',
    //     horizontal: 'right',
    //   },})
    })

    }

    useEffect(()=>{
        if(isEdit)  
            setFormData();
    },[])
    const setFormData = () => {
        addEditVersionForm.setFieldsValue({
            version:editData.version,
            paidFree:editData.isPaid ? 'Paid' : 'Free',
            rangepicker:[dayjs(editData.startDate), dayjs(editData.expiryDate)]
        })
        setIsPaid(editData.isPaid ? 'Paid' : 'Free')
    }
    return <>
    <Modal
                maskClosable={false}
                footer={null}
                title='Add/Edit Version'
                onCancel={onClosePopup}
                open={isOpen}
              > 
  <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        onFinish={onSaveStatusHandler}
        autoComplete="off"
        form={addEditVersionForm}


      >
   

       <Form.Item<FieldType>
          label="Version"
          name="version"
          rules={[{ required: true, message: "Enter Version" }]}
        >
          <Input maxLength={50} />
        </Form.Item>


       
     
     <>
            <Form.Item name="rangepicker" label="Validity" {...rangeConfig}>
      <RangePicker  
/>
    </Form.Item>
        
          </>
  

<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
<Button className="pm-btn" type="primary" htmlType="submit">
          Save
        </Button>
        </Form.Item>

      </Form>
              </Modal>
    </>
}

export default AddEditVersion;